import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { FractionalSection } from "@/components/sections/FractionalSection";
import { CTASection } from "@/components/sections/CTASection";

const Fractional = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20">
        <FractionalSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Fractional;
